import mqtt from 'mqtt';
import { MQTT_BROKER_URL, BROKER_OPTIONS } from '../constants';
import { connectMqtt, mqttMessageReceived, disconnectMqtt, addSubscribedTopic, removeSubscribedTopic } from '../redux/mqttSlice';

let client = null; // client stored in global variable here and not in Redux because redux doesn't support storing non-serializable objects (objects that contain functions, like client)
let topicCallbacks = {};  // global listener registry for topic-specific callback mapping. Callbacks added to array when subscribing, and called in .on('message') function.

const publishMessage = (topic, message, retain=true) => {
    // Check if the client is connected before publishing
    if (client.connected) {
      client.publish(topic, message, {retain: retain});
      console.log(`Published to topic "${topic}": ${message}`);
    } else {
      console.warn('MQTT client is not connected. Unable to publish message.');
    }
};

const subscribeToTopic = (topic) => {
    client.subscribe(topic, { qos: 1 }, (error) => {
        if (!error) {
          console.log(`Subscribed to topic "${topic}"`);
        } else {
          console.log(`Failed to subscribe to topic "${topic}"`);
        }
    });
};

export const initializeClient = () => {
  if(!client) {
    client = mqtt.connect(MQTT_BROKER_URL, BROKER_OPTIONS);
    console.log('MQTT client initialized:', client, MQTT_BROKER_URL);

    client.on('connect', () => {
      console.log('Connected to MQTT broker.');
    });

    // Attach only one single "message" handler when initializing client - avoids duplicate message handling
    client.on('message', (topic, message) => {
      console.log('Received message:', topic, message.toString());
      const handler = topicCallbacks[topic];
      if (handler) handler(topic, message);
    });

    client.on('error', (err) => {
      console.error('MQTT error:', err);
    });
  } else {
    console.log('MQTT client already initialized', client);
  }
}

export const subscribeToTopics = (topics, dispatch, listener, subscribedTopics) => {

  if (!client) {
    console.error('MQTT client not initialized. Unable to subscribe to topics.');
    return;
  } 

  const newTopics = topics.filter(t => !subscribedTopics.includes(t));

  newTopics.forEach(topic => {
    topicCallbacks[topic] = listener;   // <—— register listener
    client.subscribe(topic, (err) => {
      if(!err) {
        console.log(`Subscribed to topic: ${topic}`)
        dispatch(addSubscribedTopic(topic));
      } else {
        console.error(`Failed to subscribe to topic: ${topic}`, err)
      }
    });
  });

  return () => {
    newTopics.forEach(topic => {
      delete topicCallbacks[topic];
      client.unsubscribe(topic);
      dispatch(removeSubscribedTopic(topic));
    });
  };
}

export const unsubscribeFromTopics = (topics, dispatch, subscribedTopics) => {
  if (!client || !client.connected) {
    console.error('MQTT client not initialized or not connected. Cannot unsubscribe.');
    return;
  }

  const topicsToUnsubscribe = topics.filter(topic => subscribedTopics.includes(topic));

  topicsToUnsubscribe.forEach(topic => {
    client.unsubscribe(topic, (err) => {
      if (!err) {
        console.log(`Unsubscribed from topic: ${topic}`);
        dispatch(removeSubscribedTopic(topic));
      } else {
        console.error(`Failed to unsubscribe from topic: ${topic}`, err);
      }
    });
  });
};

export const cleanupClient = () => {
  if (client) {
    client.end();
    client = null;
  }
};

// Export functions
export {publishMessage, subscribeToTopic};